function collectionListSliders() {
  document.querySelectorAll('.coll-list').forEach(function (listEl) {
    var wrapper = listEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    if (listEl.swiper) listEl.swiper.destroy(true, true);

    var slider = new Swiper(listEl, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      breakpoints: {
        500: {
          slidesPerGroup: 2,
        },
        768: {
          slidesPerGroup: 3,
        },
        1024: {
          slidesPerGroup: 4,
        },
      },
    });

    function updateCollListLock() {
      slider.allowTouchMove = wrapper.scrollWidth > listEl.clientWidth + 1;
    }

    updateCollListLock();
    window.addEventListener('resize', updateCollListLock);
  });
}

document.addEventListener('DOMContentLoaded', collectionListSliders);
document.addEventListener('shopify:section:load', collectionListSliders);
